<template>
  <div>
    <fieldset>
      <legend>Connexion</legend>
      <table class="adminEdite">
        <tr>
          <td class="width50">Acc&egrave;s anonyme</td>
          <td class="width50">
            <select
              name="allowAnonymousAccess"
              v-model="allowAnonymousAccess"
            >
              <option value="0">Refuser l'acc&egrave;s anonyme</option>
              <option value="1">Autoriser l'acc&egrave;s anonyme</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Code client pour acc&egrave;s anonyme</td>
          <td>
            <select-client
              nom="visiteurCodeClient"
              :disabled="allowAnonymousAccess==0"
              :initial-value="visiteurCodeClient"
            />
          </td>
        </tr>
        <tr>
          <td>
            Paramétrage pour client anonyme
          </td>
          <td>
            <multi-select
              id="anonymousParametragesWidget"
              :options="JSON.parse(paramListe)"
              :selected="anonymousParametrages"
              nom="anonymousParametrages"
              cle="code"
              valeur="libelle"
              :disabled="allowAnonymousAccess==0"
            />
          </td>
        </tr>
        <tr>
          <td>
            Limiter la création de compte
          </td>
          <td>
            <p class="flex-fJstart-fAcenter">
              <label>
                <input
                  type="checkbox"
                  name="allowParAccount"
                  :checked="allowParAccount != 0"
                > aux particuliers
              </label>
              <label>
                <input
                  type="checkbox"
                  name="allowProAccount"
                  :checked="allowProAccount != 0"
                > aux professionnels
              </label>
            </p>
          </td>
        </tr>
        <tr>
          <td>Commandes anonymes</td>
          <td>
            <select
              name="allowAnonymousCommande"
              :disabled="allowAnonymousAccess==0"
              v-model="allowAnonymousCommande"
            >
              <option value="0">Interdire</option>
              <option value="1">Autoriser</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Compte client temporaire
            <br>
            <a
              class="indent"
              :href="'/openweb/admin/admin_parametrageInterfaceEdite?urlFrom='+dataUrl"
            >
              Préfixe code client temporaire
            </a>
          </td>
          <td>
            <select
              name="anonymousAccount"
              v-model="anonymousAccount"
            >
              <option value="0">Refuser la création de comptes temporaires</option>
              <option value="1">Autoriser la création de comptes temporaires</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Paramétrage pour clients temporaires</td>
          <td>
            <select
              name="typeClientTemporaire"
              :disabled="anonymousAccount==0"
              v-model="typeClientTemporaire"
            >
              <option
                v-for="option in JSON.parse(paramListe)"
                :key="option.code"
                :value="option.code"
              >
                {{ option.libelle }}
              </option>
            </select>
          </td>
        </tr>
      </table>
    </fieldset>
    <fieldset v-if='dataShowEnCours'>
      <legend>Encours client</legend>
      <table class="adminEdite">
        <tr>
          <td>Contrôler l'encours du client à la connexion et à la validation du panier</td>
          <td>
            <select
              name="activateEncoursChecking"
              v-model="activateEncoursChecking"
            >
              <option value="0">Désactivée</option>
              <option value="1">Activée</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Contrôler la nature de paiement autorisé à la validation du panier</td>
          <td>
            <select
              name="blockOfflinePayment"
              v-model="blockOfflinePayment"
            >
              <option value="0">Désactivée</option>
              <option value="1">Activée</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Obliger le paiement en ligne si l'interrogation dynamique du risque client ne répond pas</td>
          <td>
            <select
              name="blockOnEncoursError"
              v-model="blockOnEncoursError"
            >
              <option value="0">Désactivée</option>
              <option value="1">Activée</option>
            </select>
          </td>
        </tr>
      </table>
    </fieldset>
    <fieldset>
      <legend>Agence</legend>
      <table class="adminEdite">
        <tr>
          <td>
            Agence par défaut pour le tarif (pas d'agence => pas de tarif)
          </td>
          <td>
            <select
              name="agenceDefautTarif"
              v-model="agenceDefautTarif"
              required
            >
              <option
                v-for="agence in listeAgencesTarif"
                :key="agence.code_agence"
                :value="agence.code_agence"
              >
                {{ agence.libelle_agence }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Mode de sélection du choix de l'agence
            <br><i class="indent">{{ libelleNbAgences }}</i>
            <br><i class="indent">{{ libelleChoixAgence }}</i>
          </td>
          <td>
            <select
              name="modeSelectionAgence"
              v-model="modeSelectionAgence"
            >
              <option
                v-for="(libelle, code) in JSON.parse(modesSelectionAgence)"
                :key="code"
                :value="code"
              >
                {{ libelle }}
              </option>
            </select>
          </td>
        </tr>
      </table>
    </fieldset>
  </div>
</template>

<script>
import multiSelect from './atoms/MultiSelect'
import selectClient from './SelectClient'

export default {
  components: {
    'multi-select': multiSelect,
    'select-client': selectClient
  },
  props: {
    paramListe: {
      type: String,
      required: true
    },
    paramBase: {
      type: String,
      required: true
    },
    dataUrl: {
      type: String,
      required: false,
      default: ''
    },
    dataShowEnCours: {
      type: String,
      required: false,
      default: ''
    },
    libelleNbAgences: {
      type: String,
      required: false,
      default: ''
    },
    libelleChoixAgence: {
      type: String,
      required: false,
      default: ''
    },
    modesSelectionAgence: {
      type: String,
      required: true
    },
    agences: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      allowParAccount: 1,
      allowProAccount: 1,
      allowAnonymousAccess: 0,
      visiteurCodeClient: '',
      anonymousParametrages: [],
      allowAnonymousCommande: 0,
      anonymousAccount: 0,
      typeClientTemporaire: '',
      activateEncoursChecking: 0,
      blockOfflinePayment: 0,
      blockOnEncoursError: 0,
      modeSelectionAgence: 0,
      listeAgencesTarif: [],
      agenceDefautTarif: ''
    }
  },
  created: function() {
    let base =  JSON.parse(this.paramBase)

    this.allowParAccount = base.allowParAccount
    this.allowProAccount = base.allowProAccount
    this.allowAnonymousAccess = base.allowAnonymousAccess
    this.visiteurCodeClient = base.visiteurCodeClient
    this.anonymousParametrages = base.anonymousParametrages
    this.allowAnonymousCommande = base.allowAnonymousCommande
    this.anonymousAccount = base.anonymousAccount
    this.typeClientTemporaire = base.typeClientTemporaire
    this.activateEncoursChecking = base.activateEncoursChecking
    this.blockOfflinePayment = base.blockOfflinePayment
    this.blockOnEncoursError = base.blockOnEncoursError
    this.modeSelectionAgence = base.modeSelectionAgence
    this.agenceDefautTarif = base.agenceDefautTarif

    this.listeAgencesTarif = JSON.parse(this.agences)
    this.listeAgencesTarif = [
      { code_agence: '', libelle_agence: 'Aucune agence' },
      ...JSON.parse(this.agences)
    ]
  }
}
</script>
